import React from "react";
import "./LogoutModal.css";
import { FaSignOutAlt, FaExclamationTriangle } from "react-icons/fa";

const LogoutModal = ({ show, onClose, onConfirm }) => {
    if (!show) return null;

    return (
        <div className="premium-modal-overlay">
            <div className="premium-logout-card">
                <div className="logout-icon-wrapper">
                    <FaExclamationTriangle className="warning-icon" />
                </div>

                <h3 className="premium-modal-title">Confirm Logout</h3>
                <p className="premium-modal-message">
                    Are you sure you want to log out of your account? You will need to sign in again to book appointments.
                </p>

                <div className="premium-modal-actions">
                    <button className="premium-btn-secondary" onClick={onClose}>
                        Stay Logged In
                    </button>
                    <button className="premium-btn-danger" onClick={onConfirm}>
                        <FaSignOutAlt className="me-2" /> Logout
                    </button>
                </div>
            </div>
        </div>
    );
};

export default LogoutModal;
